var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27208 14.358C5.15329 15.0996 2.8335 17.9039 2.8335 21.2493C2.8335 25.1615 6.0047 28.3327 9.91683 28.3327C10.5876 28.3327 11.2372 28.2392 11.8527 28.0649M25.5391 14.358C28.6579 15.0996 30.977 17.9039 30.977 21.2493C30.977 25.1615 27.8058 28.3327 23.8937 28.3327C23.2229 28.3327 22.5733 28.2392 21.9585 28.0649M25.5002 14.166C25.5002 9.47189 21.6943 5.66602 17.0002 5.66602C12.306 5.66602 8.50016 9.47189 8.50016 14.166M12.0879 19.7484L17.0002 14.8205L22.052 19.8327M17.0002 26.916V17.3266",
    stroke: "#7E7E7E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.138be840.svg";
export { ForwardRef as ReactComponent };